import { BLANK_ROW_COLSPAN } from "../const";
/** 숫자 → 콤마 포맷 문자열 (0 이하이면 빈 문자열) */
export const formatNumberWithComma = (val) => {
    return val > 0 ? val.toLocaleString() : "";
};
/** 콤마 포함 문자열 → 정수로 변환 (소수점 이하 버림, 숫자 외 문자 제거) */
export const parseCommaNumber = (val) => {
    const integerPart = val.split(".")[0];
    const stripped = integerPart.replace(/[^0-9]/g, "");
    return stripped === "" ? 0 : Number(stripped);
};
/** 총 합계 필수 검증 룰 — :value 바인딩이므로 콤마 포맷 문자열이 넘어옴 */
export const requiredTotalCostRule = (v) => {
    const stripped = v.replace(/[^0-9]/g, "");
    const num = Number(stripped);
    if (!stripped || isNaN(num) || num <= 0)
        return "합계를 입력해주세요.";
    return true;
};
/**
 * 빈 행을 건너뛴 실제 순번 계산
 *
 * 예) 항목 3개 중 2번째가 빈 행이면:
 * [일반, 빈, 일반] → 순번은 [0, -, 1] (빈 행은 카운트 X)
 */
export const getVisibleIndex = (items, currentIdx) => {
    if (!items || currentIdx <= 0)
        return 0;
    let count = 0;
    const end = Math.min(currentIdx, items.length);
    for (let i = 0; i < end; i++) {
        if (items[i].cost_list_colspan !== BLANK_ROW_COLSPAN)
            count++;
    }
    return count;
};
